import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AppState } from '../../../app/store/rootReducers';
import { bindActionCreators, Dispatch } from 'redux';
import {
  setMenuItemsAction,
  hideMobileSubmenuItemsActions,
  showMobileMenuAction,
  hideMobileMenuAction,
} from '../../../app/store/menu/actions';
import classNames from "classnames";
import { fetchPageShellSessionAction, fetchPageShellHeaderAction } from '../../../app/store/pageShell/actions';
import { changeLanguage } from "../../../app/store/language/actions";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";
import DesktopHeader from './desktop/DesktopHeader';
import MediaQuery from 'react-responsive';
import MobileHeader from './mobile';
import Loader from "../../components/loader/Loader";
import { isMainHeaderOnCheckout } from "../../../utilites/util";
import './header.scss';

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class Header extends Component<Props, {}> {

  componentDidMount(): void {
    this.props.fetchPageShellSessionAction();
    this.props.fetchPageShellHeaderAction();
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
    if (prevProps.menuState.id !== this.props.menuState.id) {
      this.props.setMenuItemsAction(
        this.props.menuState.items, true, this.props.menuState.isLogin, this.props.menuState.id);
    }

    if (prevProps.language !== this.props.language) {
      this.props.fetchPageShellSessionAction();
      this.props.fetchPageShellHeaderAction();
      this.closeMenu();
    }
  }

  public changeLanguage(lang: string) {
    this.props.changeLanguage({ language: lang });
  }

  public showLoginMenu(name: string): void {
    let navItedId = 6;
    switch (name) {
    case "account":
      navItedId = 1;
      break;
    case "circledMenu": {
      navItedId = 6;
      break;
    }
    }
    this.props.setMenuItemsAction(
      this.props.loginInfo.item.item.genericLinks.find((el: any) => el.id === navItedId).items,
      true,
      true,
      this.props.loginInfo.item.id
    );
    this.openMenu();
  }

  showMenuItems(item: any, isLogin: boolean) {
    return this.props.setMenuItemsAction(item.items, !this.props.menuState.visible, isLogin, item.id);
  }

  hideMobileSubMenu() {
    return this.props.hideMobileSubmenuItemsActions();
  }

  openMenu() {
    this.props.showMobileMenuAction();
  }

  closeMenu() {
    this.props.hideMobileMenuAction();
  }

  render() {
    const { header, loginInfo, menuState, numberOfOrderItems, user, language, section, campaignModeStatus } = this.props;

    if (campaignModeStatus) return null;

    const labels = require(`../../../translations/${language}`);

    if (this.props.ui.loading && this.props.ui.entity === MiddlewareEntities.PAGE_DATA) {
      return <Loader loadingLabel= {labels.loading} />;
    }

    return (
      Object.keys(header.genericLinks).length && !this.props.ui.webview ? <header className={`header-container ${classNames(isMainHeaderOnCheckout() && "bg-grey")}`}>
        <MediaQuery query='(min-width: 1250px)'>
          <DesktopHeader
            header={header}
            showMenuItems={this.showMenuItems.bind(this)}
            selectedMenuItem={menuState}
            loginInfo={loginInfo}
            changeLanguage={this.changeLanguage.bind(this)}
          />
        </MediaQuery>
        <MediaQuery query='(max-width: 1249px)'>
          <MobileHeader
            header={header}
            menuState={menuState}
            showMenuItems={this.showMenuItems.bind(this)}
            hideSubmenuItems={this.hideMobileSubMenu.bind(this)}
            user={user}
            numberOfOrderItems={numberOfOrderItems}
            changeLanguage={this.changeLanguage.bind(this)}
            openMenu={this.openMenu.bind(this)}
            closeMenu={this.closeMenu.bind(this)}
            showLoginMenu={this.showLoginMenu.bind(this)}
            isLogin={menuState.isLogin}
            section={section}
            language={language}
          />
        </MediaQuery>
      </header> : null
    );
  }

}

const mapStateToProps = (state: AppState) => ({
  header: state.pageShell.data.header,
  loginInfo: state.pageShell.data.login,
  numberOfOrderItems: state.session.numberOfOrderItems,
  user: state.session.user,
  menuState: state.menuState,
  language: state.language.language,
  ui: state.ui,
  section: state.section.section,
  campaignModeStatus: state.campaign.campaignMode.status
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    setMenuItemsAction,
    hideMobileSubmenuItemsActions,
    fetchPageShellSessionAction,
    fetchPageShellHeaderAction,
    showMobileMenuAction,
    hideMobileMenuAction,
    changeLanguage,
  }, dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
